import React, { useContext } from "react";
import { SiteContext } from "../contexts/SiteContext";
import { Link } from "react-router-dom";
import { Button, makeStyles } from "@material-ui/core";

function Breadcrumbs({ links }) {
	const { selectedSite } = useContext(SiteContext);

	const useStyles = makeStyles((theme) => ({
		breadcrumbs: {
			padding: "1rem",
			margin: "0 auto",
			maxWidth: process.env.REACT_APP_MAX_WIDTH,
		},
		button: {
			fontWeight: "bold",
			fontSize: ".7rem",
			...(selectedSite.secondaryColor && {
				color: selectedSite.secondaryColor,
			}),
		},
	}));

	const classes = useStyles();

	return (
		<div className={classes.breadcrumbs}>
			<Button component={Link} to="/" className={classes.button}>
				Online Classroom
			</Button>
			{"/"}
			<Button
				component={Link}
				to={`/${selectedSite.slug}`}
				className={classes.button}
			>
				{selectedSite.name}
			</Button>
			{links &&
				links.length > 0 &&
				links.map((link, i) => (
					<React.Fragment key={i}>
						{"/"}
						<Button component={Link} to={link.url} className={classes.button}>
							{link.name}
						</Button>
					</React.Fragment>
				))}
		</div>
	);
}

export default Breadcrumbs;
